// extracted by mini-css-extract-plugin
export default {"icon":"DatePicker_icon__dP0O9","wrapper":"DatePicker_wrapper__a4Gfw","blueIcon":"DatePicker_blueIcon__Ts-NE"};